import { IServant, IIndexable } from 'core-ts-types';

export interface ICategory extends IIndexable {
  category: string;
}

export interface IHierarchyCategory<T> {
  list: T[];
  category: string;
}

export interface IHierarchyMappingOptions {
  category?: string;
  list?: string;
}
export interface IHierarchyMappingRequirements {
  category: string;
  list: string;
}

export class HierarchyCategoryServant implements IServant {
  static HIERARCHY_OPTIONS: IHierarchyMappingRequirements = {
    category: 'category',
    list: 'list'
  };

  zipTree<T extends ICategory>(
    hierarchy: IHierarchyCategory<T>[],
    options?: IHierarchyMappingOptions
  ): Record<string, T> {
    const flattenedTree: T[] = this.flattenTree(hierarchy, options);
    return _.zipObject(_.pluck(flattenedTree, 'id'), flattenedTree) as Record<string, T>;
  }

  flattenTree<T extends ICategory>(hierarchy: IHierarchyCategory<T>[], options?: IHierarchyMappingOptions): T[] {
    const opOptions: IHierarchyMappingRequirements = _.merge({}, HierarchyCategoryServant.HIERARCHY_OPTIONS, options);

    return _.flatten(
      _.map(hierarchy, (group: IHierarchyCategory<T>): T[] => {
        return _.map(
          group[opOptions.list],
          (element: T): T => {
            element.category = group[opOptions.category];
            return element;
          }
        );
      })
    );
  }
}

angular.module('capability-ng-global').service('ngHierarchyCategoryServant', HierarchyCategoryServant);



// WEBPACK FOOTER //
// ./app/lib/global/servants/hierarchy_category_servant.ts